import RightIcon from '../../../Icons/coaching/funnel/right-icon.svg'
import SectionHeading from '../../HomePage/SectionHeading'

// const offerItems = [
//   { text: 'Free Coaching Call (Worth $250)', worth: '$250' },
//   { text: '1500 Free Leads (Worth $400)', worth: '$400' },
//   { text: '10% OFF', worth: '' },
//   { text: 'Free Resources (Worth $500)', worth: '$500' },
// ]

const freeResources = [
    {
        title: 'Business Setup Checklist',
        description:
            'Step-by-step guide to setting up your real estate business.',
    },
    {
        title: 'Phone Scripts',
        description: 'To guide your conversations with prospects and leads.',
    },
    {
        title: 'Assignment Contract',
        description:
            'A template for assigning your real estate contract to another buyer.',
    },
    {
        title: 'Recommended Prospect Lists',
        description:
            'Our recommended lists to target the best potential contacts.',
    },
    {
        title: 'FOIA Request Template',
        description:
            'To request tax liens and other public records using the Freedom of Information Act.',
    },
    {
        title: 'Agreement to Extend Closing Date',
        description:
            'A template to extend the closing date of a purchase or sale.',
    },
    {
        title: 'General List Criteria',
        description:
            'To help you identify and compile your list of potential contacts.',
    },
    {
        title: 'Purchase Contract',
        description: 'A template for purchasing and selling real estate.',
    },
    {
        title: 'Deal Analysis Tool',
        description:
            'To help you evaluate the profitability of potential deals.',
    },
]

const FreeOffers = () => {
    return (
        <div className="container m-auto p-6 text-center space-y-8">
            <div className="space-y-10">
                <SectionHeading>
                    <p>
                        Free Resources{' '}
                        <span className="olm-gradient-text">
                            {' '}
                            + 1500 Free Leads{' '}
                        </span>{' '}
                    </p>
                </SectionHeading>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
                    {freeResources.map((resource, index) => (
                        <div key={index} className="flex items-start space-x-2">
                            <span className="text-orange-500 mt-1">
                                <RightIcon />
                            </span>
                            <div>
                                <h3 className="font-semibold text-xl">
                                    {resource.title}
                                </h3>
                                <p className="text-md">
                                    {resource.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default FreeOffers
